module.exports = __webpack_public_path__ + "588880a9b7cf82740f8bbed7f7b3efec.md";